// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCd-nLw2A0VMRl1qvUvzbm7DaGhTLixx_8",
  authDomain: "rentin-syokudo.firebaseapp.com",
  projectId: "rentin-syokudo",
  storageBucket: "rentin-syokudo.appspot.com",
  messagingSenderId: "698868153708",
  appId: "1:698868153708:web:cfc79e83d4d3be5acbc749",
  measurementId: "G-RVTV99XVSW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

export default app;